import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: "/jbxx",
      // component: Home,
    },
    {
      path: "/home",
      name: "home",
      component: Home,
    },
    {
      path: "/hb",
      name: "hb",
      component: () => import("./views/hb.vue"),
    },
    {
      path: "/jbxx",
      name: "jbxx",
      component: () => import("./views/jbxx1.vue"),
    },
    {
      path: "/success",
      name: "success",
      component: () => import("./views/success.vue"),
    },
  ],
});
